// Minnesotaänger Mini App — v1 global init actions.
// New code (not from telegram-tt). The telegram-tt init handler built a
// per-tab state tree, migrated threads, restored cache, and coordinated
// master/slave tabs; v1 has none of that — the global tree is ready as-is
// and the app starts with the conversation list empty.

import './intervals';

import type { ActionReturnType } from './types';

import { initGlobal } from '../util/init';
import { addActionHandler } from './index';

initGlobal();

addActionHandler('init', (): ActionReturnType => undefined);
